import axios from 'axios'
// 携带cookie
axios.defaults.withCredentials = true;

axios.defaults.baseURL = '//api1.cyzone.cn';
export default axios;
